/**
 * 竞价车辆信息项目
 */
import React from 'react';
import { numFormat } from '../../../util/util'
import completeImg from "./img/complete.png";
import waitBeginImg from "./img/waitBegin.png";
import failImg from "./img/fail.png";
import deal2Img from "./img/deal2.png";
import lowPriceImg from "./img/lowPrice1.png";
import auctionIngImg from "./img/auctioning.png";
import http from '../../../axios/http';

class AuctionedItem extends React.Component {

    state = {
        base64Data: "",
    }

    componentDidMount() {
        let data = this.props.item;
        if (data) {
            this.getWatermarkImage(data.vehicleImageUrl);
        }
    }

    componentWillReceiveProps(nextProps) {
        let oldUrl = this.props.item.vehicleImageUrl;
        let newUrl = nextProps.item.vehicleImageUrl;
        if (oldUrl !== newUrl) {
            this.getWatermarkImage(newUrl);
        }
    }

    getWatermarkImage = (url) => {
        http.post({
            url: "/common/getWatermarkImage",
            data: {url: url},
            success: (res) => {
                this.setState({
                    base64Data: "data:image/jpeg;base64," + res,
                })
            }
        })
    }
    render() {
        let data = this.props.item;
        let itemClassName = 'auction-item four-col';
        if (this.props.center) {
            itemClassName = 'auction-item four-col center-item'
        }
        const status = data.status;
        let endTime = data.endTime ? data.endTime : this.props.startTime;
        return (
            <div className={itemClassName} onClick={this.props.lotsDetail.bind(this, data.id)} style={{margin: "0 1% 2.7vh 1%"}}>
                <div className='auction-img' style={{ backgroundImage: "url(" + this.state.base64Data + ")"}}>
                    {status !== undefined &&  status !== null&&status!==4 ? <img className="auction-result-img" src={status === 0 ? failImg : (status === 1 ? deal2Img : lowPriceImg)} alt="auction-result" /> : ""}    
                    <div className='auction-img-bottom'>
                        <span className="session-title-time"><span className='iconfont icon-clock red-color'></span>&nbsp;{endTime}  </span>
                        <div className='gradient-div'>
                            <img className="complete-img" src={status ===0||status ===1||status ===2 ? completeImg : (status===4? auctionIngImg:waitBeginImg) } alt="complete-img" />
                        </div>
                    </div>
                </div>
                <div className='auction-detail'>
                    <div className='car-name'>
                        {data.name}
                    </div>
                    <div className='price-info'>
                        <span className='item-price-label'>最高价</span>&nbsp;&nbsp;
                                    <span className='item-price-tag red-color'>{data.finalPrice ? "￥"+numFormat(data.finalPrice) : ''}</span><br />
                        <span className='item-price-label'>起始价</span>&nbsp;&nbsp;
                                    <span className='item-price-label'>￥{numFormat(data.startPrice)}</span>
                    </div>
                    <div className='follow-box'>
                        <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{data.bidTimes ? data.bidTimes : '0'}</span> &nbsp;&nbsp;人出价</span><br />
                        <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{data.followNum ? data.followNum : '0'}</span> &nbsp;&nbsp;人关注</span><br />
                    </div>
                </div>
            </div>
        );
    }
}
export default AuctionedItem;